import { TextFieldProps } from '@mui/material';

import { ObjectValues } from 'helpers/types';

export const LOOK = {
  SUCCESS: 'success',
  FAILED: 'failed',
  DEFAULT: 'default',
} as const;

export type ILook = ObjectValues<typeof LOOK>;

export type ITotalSumInputProps = TextFieldProps & {
  name: string;
  look?: ILook;
  allowNegative?: boolean;
  disabled?: boolean;
  decimalScale?: number;
};
